/* TikTok-Wortmarke als schlichtes SVG-Glyph (lucide hat kein TikTok-Icon). currentColor, damit es sich wie die übrigen Footer-Icons einfärbt. */
export const TikTokIcon = ({ size = 18, className = "", ...rest }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" className={className} {...rest}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 4v2.6c-1.3.1-2.5-.2-3.6-.8v6.2c0 3.2-2.4 5.5-5.5 5.5A5.4 5.4 0 0 1 5.5 15c0-3 2.4-5.4 5.4-5.4.3 0 .6 0 .9.1v2.8c-.3-.1-.6-.2-.9-.2a2.7 2.7 0 1 0 2.7 2.7V3h2.4Z" />
  </svg>
);
